/**
 * Query-key factory for the tools slice. A stable ``all`` root lets a favorite
 * mutation invalidate the whole subtree after a write. The directory key carries
 * the action so a different action is cached separately.
 */
export const toolKeys = {
  all: ["tools"] as const,
  directory: (action: string | null) =>
    [...toolKeys.all, "directory", action ?? "none"] as const,
  directorySectors: () => [...toolKeys.all, "directory-sectors"] as const,
  favorites: (action?: string | null) =>
    [...toolKeys.all, "favorites", action ?? "all"] as const,
  admin: () => [...toolKeys.all, "admin"] as const,
  adminList: () => [...toolKeys.admin(), "list"] as const,
  adminDetail: (id: string) => [...toolKeys.admin(), "detail", id] as const,
  adminCatalog: () => [...toolKeys.admin(), "action-catalog"] as const,
  adminHistory: (id: string | null) =>
    [...toolKeys.admin(), "history", id ?? "none"] as const,
  adminLinkChanges: () => [...toolKeys.admin(), "link-changes"] as const,
  adminLinkChange: (id: string) =>
    [...toolKeys.admin(), "link-change", id] as const,
  adminActionOrder: (actionId: string) =>
    [...toolKeys.admin(), "action-order", actionId] as const,
} as const;
